import { useQuery } from '@tanstack/react-query'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'
import {
  AwardedStudentsPreviewParams,
  getAwardedStudentsPreview,
} from '@/queries/program_purses/requests.ts'

type UseAwardedStudentsPreviewParams = AwardedStudentsPreviewParams & {
  enabled: boolean
}

export const useAwardedStudentsPreview = ({
  programId,
  purseId,
  enabled,
}: UseAwardedStudentsPreviewParams) => {
  return useQuery({
    queryKey: PURSE_KEYS.AWARDED_STUDENTS_PREVIEW(programId, purseId),
    queryFn: () => getAwardedStudentsPreview({ programId, purseId }),
    // The awarded set changes whenever ServiceNow publishes, so never show a cached total
    // as the basis for a funding decision.
    staleTime: 0,
    enabled,
  })
}
